import { useTranslation } from 'react-i18next'

import { Checkbox } from '../../../../../../../Checkbox'
import Text from '../../../../../../../Text'

import * as styles from './ListingProfileApplicantsMatchRulesModalBudgetGate.module.css'

function ListingProfileApplicantsMatchRulesModalBudgetGate({
  criterion,
  isGate,
  isReadOnly,
  onChange,
}) {
  const { t } = useTranslation()

  function handleChange() {
    onChange(!isGate)
  }

  return (
    <span className={styles.ListingProfileApplicantsMatchRulesModalBudgetGate}>
      <Text isSecondary>{criterion.listing_value}</Text>
      <Checkbox
        checked={isGate}
        disabled={isReadOnly}
        label={t('RentalPortal.MatchRulesBudgetGateKey')}
        onChange={handleChange}
      />
    </span>
  )
}

export default ListingProfileApplicantsMatchRulesModalBudgetGate
